export default __webpack_public_path__ + "static/media/results.3b618fc4.svg";